import { render, staticRenderFns } from "./RechargeInfo.vue?vue&type=template&id=04424778&scoped=true"
import script from "./RechargeInfo.vue?vue&type=script&lang=ts"
export * from "./RechargeInfo.vue?vue&type=script&lang=ts"
import style0 from "./RechargeInfo.vue?vue&type=style&index=0&id=04424778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04424778",
  null
  
)

export default component.exports